import { render, staticRenderFns } from "./joinus.vue?vue&type=template&id=15009932&scoped=true&"
import script from "./joinus.vue?vue&type=script&lang=js&"
export * from "./joinus.vue?vue&type=script&lang=js&"
import style0 from "./joinus.vue?vue&type=style&index=0&id=15009932&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15009932",
  null
  
)

export default component.exports